module.exports = value => value.toString().replace(RegExp('[^0-9]', 'gmi'), '')
